import { MESApiService } from "@dexteel/mesf-core";

export const getTundishes = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[CAS].[GetTundishes]", []);
};
